import React from "react";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import {
  CheckBoxSelection,
  Inject,
  MultiSelectComponent,
} from "@syncfusion/ej2-react-dropdowns";
import {
  getCurrentLangFromRedux,
  getDir,
} from "../../../algorithms/styleChanges";

const DropDownList = ({
  placeholder,
  containerStyle,
  inputStyle,
  enabled,
  dataSource,
  change,
  readOnly,
  allowFiltering,
  filterBarPlaceholder,
  filterType,
  borderWidth,
  disabled,
  maxSelect,
  borderStyle,
  multiSelect,
  border,
  focus,
  errorMessage,
  value,
  blur,
  id,
  showClearButton,
  text,
  field,
  style,
  name,
}) => {
  const fields = field ? { ...field } : { text: "name", value: "id" };
  const haveborder = border == false ? false : true;
  const dir = getDir(getCurrentLangFromRedux());
  return (
    <div className={containerStyle}>
      <div
        className={` dropdown_style `}
        style={{
          borderWidth: `${haveborder ? (borderWidth ?? 1) : 0}px `,
          borderStyle: ` ${borderStyle ?? "solid"}`,
          position: "relative",
          paddingLeft: 2,
          paddingRight: 2,
          height: 45,
          zIndex: 100,
          cursor: "pointer",
          ...style,
        }}
      >
        {multiSelect ? (
          <MultiSelectComponent
            value={value}
            {...(text ? { text } : {})}
            showClearButton={showClearButton ?? false}
            maximumSelectionLength={maxSelect ?? 3}
            id="checkbox"
            mode="CheckBox"
            dataSource={dataSource}
            fields={fields}
            placeholder={placeholder ?? ""}
            allowFiltering={allowFiltering}
            filterType={filterType ?? "Contains"}
            cssClass={inputStyle + " " + "noborder"}
            enableRtl={dir === "ltr" ? false : true}
            enabled={enabled ?? true}
            readOnly={readOnly ?? false}
            disabled={disabled ?? false}
            change={change}
            floatLabelType="Auto"
            filterBarPlaceholder={filterBarPlaceholder ?? ""}
            focus={focus}
          >
            <Inject services={[CheckBoxSelection]} />
          </MultiSelectComponent>
        ) : (
          <>
            <DropDownListComponent
              value={value}
              {...(text ? { text } : {})}
              htmlAttributes={{
                id: id,
              }}
              showClearButton={showClearButton ?? false}
              dataSource={dataSource}
              fields={fields}
              allowFiltering={allowFiltering}
              filterType={filterType ?? "Contains"}
              floatLabelType="Auto"
              placeholder={placeholder ?? ""}
              cssClass={inputStyle + " " + "noborder "}
              enableRtl={dir == "ltr" ? false : true}
              change={change}
              filterBarPlaceholder={filterBarPlaceholder ?? ""}
              enabled={enabled ?? true}
              readOnly={readOnly ?? false}
              disabled={disabled ?? false}
              focus={focus}
              blur={blur}
              name={name}
            />
          </>
        )}
      </div>
      <div style={{ fontSize: 14, color: "red" }}> {errorMessage ?? ""}</div>
    </div>
  );
};

export default DropDownList;
